import { useMixpanel } from 'gatsby-plugin-mixpanel';
import React, { ReactElement, useEffect } from 'react';
import { Text } from '../';

type IProps = {
  excludedPlatform: string;
};

export default function FreeDownloadPlatforms({
  excludedPlatform,
}: IProps): ReactElement {
  const mixpanel = useMixpanel();

  useEffect(() => {
    mixpanel.track_links('#download--figma', 'Download clicked', {
      platform: 'Figma',
    });
    mixpanel.track_links('#download--sketch', 'Download clicked', {
      platform: 'Sketch',
    });
    mixpanel.track_links('#download--xd', 'Download clicked', {
      platform: 'XD',
    });
    mixpanel.track_links('#download--chrome', 'Download clicked', {
      platform: 'Chrome',
    });
    mixpanel.track_links('#download--firefox', 'Download clicked', {
      platform: 'Firefox',
    });
    mixpanel.track_links('#download--edge', 'Download clicked', {
      platform: 'Edge',
    });
    mixpanel.track_links('#download--safari', 'Download clicked', {
      platform: 'Safari',
    });
    mixpanel.track_links('#download--arc', 'Download clicked', {
      platform: 'Arc',
    });
    mixpanel.track_links('#download--brave', 'Download clicked', {
      platform: 'Brave',
    });
  }, [mixpanel]);

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center">
      <div className="suite-platforms mt-12 flex flex-wrap justify-between gap-6">
        {excludedPlatform !== 'Figma' && (
          <a
            id="download--figma"
            target="_blank"
            href="https://www.figma.com/community/plugin/732603254453395948"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/figma.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Figma
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Sketch' && (
          <a
            id="download--sketch"
            target="_blank"
            href="/sketch/download"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/sketch.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Sketch
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Adobe XD' && (
          <a
            id="download--xd"
            target="_blank"
            href="https://exchange.adobe.com/apps/cc/6cbf275e/stark"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/xd.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Adobe XD
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Chrome' && (
          <a
            id="download--chrome"
            target="_blank"
            href="https://chrome.google.com/webstore/detail/stark/fkfaapnmfippddbeemjjbclenphooipm"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/chrome.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Chrome
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Firefox' && (
          <a
            id="download--firefox"
            target="_blank"
            href="https://addons.mozilla.org/en-US/firefox/addon/stark-accessibility-checker/"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/firefox.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Firefox
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Edge' && (
          <a
            id="download--edge"
            target="_blank"
            href="https://microsoftedge.microsoft.com/addons/detail/stark/idpodoagbkllmpdjdepbmlefgiblmnhl"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/edge.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Edge
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Safari' && (
          <a
            id="download--safari"
            target="_blank"
            href="https://apps.apple.com/us/app/stark-for-safari/id6444031666"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/safari.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Safari
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Arc' && (
          <a
            id="download--arc"
            target="_blank"
            href="https://chrome.google.com/webstore/detail/stark/fkfaapnmfippddbeemjjbclenphooipm"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/arc.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Arc
            </Text>
          </a>
        )}

        {excludedPlatform !== 'Brave' && (
          <a
            id="download--brave"
            target="_blank"
            href="https://chrome.google.com/webstore/detail/stark/fkfaapnmfippddbeemjjbclenphooipm"
            title="(opens in new tab)"
            className="group flex flex-col items-center font-normal no-underline">
            <img
              className="h-[60px] w-[70px] transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,_0,_0,_0.16)] group-hover:group-odd:rotate-[-4deg] group-hover:group-odd:scale-[1.02]"
              alt=""
              src="https://images.getstark.co/marketing/platforms/brave.png"
            />
            <Text level="semibold" className="mt-4">
              Stark for Brave
            </Text>
          </a>
        )}
      </div>
    </div>
  );
}
